import { Button, Col, Row, Space, Typography } from "antd";
import React, { useMemo, useState } from "react";
import DetailItem from "../../../components/DetailItem";
import UserTransferHistory from "../../../components/UserTransferHistory";
import { EMPLOYEE_ROLES_MAPPING_LONG } from "../../../types/employee.type";
import { UserProperties } from "../../../types/user.type";
import { priceFormat } from "../../../helpers/priceFormat";
import useAuth from "../../../hooks/useAuth";

interface Props {
	user?: UserProperties;
	isSmall?: boolean;
	isTransferListing?: boolean;
	includeTextStaff?: boolean;
}
const { Text } = Typography;
const EmployeeInformation: React.FC<Props> = ({ user, isSmall, isTransferListing, includeTextStaff }) => {
	const [showTransferHistory, setShowTransferHistory] = useState<boolean>(false);
	const { isFOPlus } = useAuth();

	const employee = useMemo(() => user?.employee?.[0], [user]);

	return user !== undefined ? (
		<div
			className="grey-card transfer-user-card"
			style={{ marginTop: 20 }}
		>
			<Row
				gutter={[24, 0]}
				wrap={true}
			>
				<Col flex={isSmall ? "130px" : "150px"}>
					<img
						className="card-user-photo"
						alt={user?.nickName}
						src={user?.profilePic ?? "/images/no-preview.jpg"}
					/>
				</Col>
				<Col flex="auto">
					<Row>
						<Col
							span={24}
							md={12}
						>
							<DetailItem
								label="Agent ID"
								value={employee?.employeeCode}
							/>
						</Col>
						<Col
							span={24}
							md={12}
						>
							<DetailItem
								label="Agent Name"
								value={user.nickName}
							/>
						</Col>
						{isTransferListing ? (
							(employee?.employeeRole ?? [])?.length > 1 ? (
								<Col
									span={24}
									md={12}
								>
									<DetailItem
										label="Current Role"
										value={employee?.employeeRole
											?.map((row) => EMPLOYEE_ROLES_MAPPING_LONG[row.role])
											.join(", ")}
									/>
								</Col>
							) : (
								<></>
							)
						) : (
							<Col
								span={24}
								md={12}
							>
								<DetailItem
									label="Current Role"
									value={employee?.employeeRole
										?.map((row) => EMPLOYEE_ROLES_MAPPING_LONG[row.role])
										.join(", ")}
								/>
							</Col>
						)}

						{!isTransferListing && (
							<Col
								span={24}
								md={12}
							>
								<DetailItem
									label="GC to Date"
									value={user.totalCommission}
									renderValue={(v) => priceFormat(v)}
								/>
							</Col>
						)}

						{isFOPlus && (
							<Col
								span={24}
								md={12}
							>
								<DetailItem
									label="Office"
									value={employee?.office?.officeName}
								/>
							</Col>
						)}

						{!isSmall && (
							<Col
								span={24}
								md={12}
							>
								<Button
									type="primary"
									onClick={() => setShowTransferHistory(true)}
								>
									See Transfer History
								</Button>
							</Col>
						)}
					</Row>
				</Col>
			</Row>
			<UserTransferHistory
				open={showTransferHistory}
				userId={user.userId}
				onClose={() => setShowTransferHistory(false)}
			/>
		</div>
	) : (
		<div
			className="grey-card transfer-user-card flex-justify"
			style={{ marginTop: 20 }}
		>
			<Space
				direction="vertical"
				className="center"
			>
				<Text>Detail {includeTextStaff ? "Staff/Agent" : "Agent"} Empty</Text>
				<Text type="secondary">
					Select {includeTextStaff ? "Staff or Agent" : "Agent"} first in order to display information
				</Text>
			</Space>
		</div>
	);
};
export default EmployeeInformation;
